import { Box, CircularProgress, Typography } from "@material-ui/core";
import React from "react";

const MigrateData = () => {
    return (
        <Box
            padding={5}
            style={{
                width: "fit-content",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
            <Typography variant="h4" style={{ fontWeight: 500 }}>
                Tilslutter til Dinero.
            </Typography>
            <CircularProgress style={{ marginTop: "100px" }} />
            <Typography variant="subtitle1">
                Kopierer klienter, produkter og fakturaer fra HandsOn Booking til Dinero
            </Typography>
            <Typography variant="subtitle1" style={{ marginTop: "35px" }}>
                Luk ikke denne fane før processen er færdig!
            </Typography>
            <Typography variant="subtitle1">Du kan frit navigere på andre faner</Typography>
            <Typography style={{ fontSize: "12px", marginTop: "17px" }}>Det kan tage op til flere minutter</Typography>
        </Box>
    );
};

export default MigrateData;
